var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.675 10.475L1.25 14.75L5.525 13.325C7.47751 14.3112 9.86606 14.1969 11.7256 13.047C13.767 11.7845 14.75 9.58758 14.75 7.25002C14.5737 4.05494 11.9451 1.42629 8.75 1.25002H8.375C7.3851 1.24744 6.40859 1.47872 5.525 1.92502C4.46619 2.4542 3.57562 3.26771 2.95304 4.27443C2.33046 5.28116 2.00046 6.44134 2 7.62502C1.99742 8.61492 2.2287 9.59144 2.675 10.475Z",
    stroke: "#2D3D38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.409c4fe158baa16406020ea875e20fe7.svg";
export { ForwardRef as ReactComponent };